import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Text from "@mui/material/Typography";
import { useState } from "react";
import { useSelector } from "react-redux";
import { a11yProps, TabPanel } from "../../../components/Tabs/TabPanel";
import { Colors } from "../../../utils/constants";
import AddBooks from "./AddBooks";
import Add from "./AddTOC";
import { alertStyles as styles } from "./Alerts.style";
import AudioVideo from "./AudioVideo";
import Dataset from "./Dataset";
import ManageBooks from "./ManageBooks";
import Manage from "./ManageTOC";
import Patents from "./Patents";
import PrePrint from "./PrePrint";
import SearchAlerts from "./SearchAlerts";
import Theses from "./Thesis";
import { Padding } from "@mui/icons-material";

const Alerts = () => {
  const [alertType, setAlertType] = useState(0);
  const [value, setValue] = useState(0);

  const handleChange = (_: any, newValue: number) => setValue(newValue);

  const handleSelectAlert = (type: number) => setAlertType(type);
  const datatypes = useSelector((state:any)=>state?.customer?.customerDetails?.datatypes)?.map((item:any)=>{return item?.dat_resourcetype_id});

  return (
    <>
      {/* Header Tab */}
      <Box sx={styles.selectTextWrapper}>
        <Text
          sx={{
            p: 1,
            backgroundColor: !alertType ? Colors.primary : Colors.white,
            borderRadius: "0.5rem 0 0 0.5rem",
            borderRight: "1px solid",
            borderColor: Colors.gray_400,
            color: !alertType ? Colors.white : Colors.black,
          }}
          onClick={() => handleSelectAlert(0)}
        >
          TOC Alerts
        </Text>
        <Text
          sx={{
            p: 1,
            backgroundColor: alertType ===1  ? Colors.primary : Colors.white,
            color: alertType === 1? Colors.white : Colors.black,
            borderRight: "1px solid",
            borderColor: Colors.gray_400,
          }}
          onClick={() => handleSelectAlert(1)}
        >
          Subject Alerts
        </Text>

        {/* <Text
          sx={{
            p: 1,
            backgroundColor: alertType === 2 ? Colors.primary : Colors.white,
            borderRadius: "0 0.5rem 0.5rem 0",
            color: alertType ===2 ? Colors.white : Colors.black,
          }}
          onClick={() => handleSelectAlert(2)}
        >
         Favorite Books
        </Text> */}
      </Box>

      {/* TOC Alert */}
      {alertType === 0 && (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Add" {...a11yProps(0)} />
              <Tab label="Manage" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Add />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Manage />
          </TabPanel>
        </Box>
      )}

      {/* Subject Alert */}
      {alertType === 1 && (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ maxWidth:"100%",borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Search Alerts" {...a11yProps(0)} sx={TabsStyles}/>
              <Tab label="Theses" {...a11yProps(1)}  sx={TabsStyles}/>
              <Tab label="Audio & Video" {...a11yProps(2)}  sx={TabsStyles}/>
              <Tab label="Pre-Print" {...a11yProps(3)}  sx={TabsStyles}/>
             { datatypes.includes(6) &&<Tab label="Dataset" {...a11yProps(4)}  sx={TabsStyles}/>}
              { datatypes.includes(25) && <Tab label="Patents" {...a11yProps(5)}  sx={TabsStyles}/>}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <SearchAlerts />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Theses />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <AudioVideo />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <PrePrint />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Dataset />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <Patents/>
          </TabPanel>
        </Box>
      )}

{alertType === 2 && (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Add" {...a11yProps(0)} />
              <Tab label="Manage" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <AddBooks />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ManageBooks />
          </TabPanel>
          
        </Box>
      )}
    </>
  );
};

export default Alerts;

const TabsStyles:any = {
  fontSize:{xs:".6rem",sm:".75rem",md:".95rem"},
  '.MuiTab-root':{
    Padding:0
  }
}
